import React from "react";

//Import Breadcrumb
import { Checkbox, FormControlLabel, FormHelperText, FormLabel, Grid, InputAdornment, Stack } from "@mui/material";
import { connect } from 'react-redux';
import CustomButton from "../../../components/Form/CustomButton";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import CustomizedDatePicker from "../../../components/Form/DatePicker";
import "../../Orders/order.css";

const DiscountField = ({ setOpenDiscountField, tempDiscount, error, setTempDiscount, errorDate, errorQty, edit, setEditId, handleSaveEdit, id, handleAddDiscount, setError, setErrorDate, setErrorQty, setNotification }) => {
    return (
        <div className="pt-4">
            <Grid container sx={{ border: '1px solid #e0e0e0', borderRadius: "8px", backgroundColor: "#fafafa" }} p={2} pt={0}>
                <Grid item xs={12} pb={2}>
                    <Stack direction={{ xs: "column-reverse", sm: "row" }} pt={2} gap={1} justifyContent={"space-between"}>
                        <Stack direction={"row"} gap={1} alignItems={"center"}>
                            <div style={{ border: '1px solid #D0D0D0', borderRadius: "5px", height: "42px", width: "42px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <i className="ri-price-tag-3-line" style={{ fontSize: "24px" }}></i>
                            </div>
                            <div>
                                <span className="setting-form-section-header font-size-14" >Set up a discount</span>
                            </div>
                        </Stack>
                        <div className="d-flex justify-content-end">
                            <CustomButton
                                borderStyle={"1px solid #999999"}
                                title={<span><i className="ri-close-fill me-2"></i>Cancel</span>}
                                press={() =>
                                    edit
                                        ? (setEditId(), setError(false), setErrorDate(false), setErrorQty(false))
                                        : (setOpenDiscountField(false), setError(), setErrorDate(), setErrorQty())
                                } height={26}
                                backgroundColor={'transparent'}
                                textColor={'#999999'}
                            />
                        </div>
                    </Stack>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} style={{ width: "100px" }}>
                        <CustomSelect
                            title={'Discount Type'}
                            values={tempDiscount?.discount_type || '-1'}
                            valueName={"id"}
                            labelName={"name"}
                            placeholder={"Select"}
                            onChange={(e) => setTempDiscount((prevValues) => ({
                                ...prevValues,
                                discount_type: e,
                                discount_value: "",
                            }))}
                            error={error && !tempDiscount?.discount_type && "The product discount type field is required."}
                            data={[{ id: "percentage", name: "Percentage Discount (%)" }, { id: "fixed", name: "Fixed Amount Discount (S$)" }]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CustomTextField
                            title={'Discount value'}
                            values={tempDiscount?.discount_value}
                            error={error && !tempDiscount?.discount_value && "The product discount value field is required."}
                            onChange={(e) =>
                                tempDiscount?.discount_type === "percentage" ?
                                    e > 100 ?
                                        setNotification({ open: true, msg: 'Discount percentage cannot exceed 100%', type: 'warning' })
                                        :
                                        setTempDiscount((prevValues) => ({
                                            ...prevValues,
                                            discount_value: e
                                        }))
                                    :
                                    setTempDiscount((prevValues) => ({
                                        ...prevValues,
                                        discount_value: e
                                    }))

                            }
                            InputProps={{
                                startAdornment: tempDiscount?.discount_type === "fixed" && <InputAdornment position="start" className='auth-icon'>{"S$"}</InputAdornment>,
                                endAdornment: tempDiscount?.discount_type === "percentage" && <InputAdornment position="end" className='auth-icon'>{"%"}</InputAdornment>,
                            }}
                            type="number"
                            placeholder={tempDiscount?.discount_type === "1" ? "Enter discount percentage" : "Enter discount amount"}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} >
                        <CustomizedDatePicker
                            title={'Start Date'}
                            values={tempDiscount?.discount_start && new Date(tempDiscount.discount_start)}
                            setFormValues={setTempDiscount}
                            name={'discount_start'}
                            error={error ? !tempDiscount?.discount_start && "The discount start date is required." : errorDate && tempDiscount?.discount_start && (tempDiscount?.discount_start > tempDiscount?.discount_end) && "The start date must be a date before end date."}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CustomizedDatePicker
                            title={'End Date'}
                            values={tempDiscount?.discount_end && new Date(tempDiscount.discount_end)}
                            setFormValues={setTempDiscount}
                            name={'discount_end'}
                            error={error ? !tempDiscount?.discount_end && "The discount end date is required." : errorDate && tempDiscount?.discount_end && (tempDiscount?.discount_start > tempDiscount?.discount_end) && "The end date must be a date after start date."}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CustomTextField
                            title={'Min purchase quantity'}
                            values={tempDiscount?.min_purchase_qty || ""}
                            error={error ? !tempDiscount?.min_purchase_qty && "The min purchase quantity must be at least 1" : errorQty && tempDiscount?.min_purchase_qty <= 0 ? "The min purchase quantity field must be at least 1." : (tempDiscount?.min_purchase_qty > tempDiscount?.max_purchase_qty) && "The product min purchase quantity must less than max purchase quantity."}
                            onChange={(e) => {
                                setTempDiscount((prevValues) => ({
                                    ...prevValues,
                                    min_purchase_qty: e,
                                }));
                            }}
                            type="number"
                            placeholder={""}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CustomTextField
                            title={'Max purchase quantity'}
                            values={tempDiscount?.max_purchase_qty}
                            error={error ? !tempDiscount?.max_purchase_qty && "The max purchase quantity field is required" : errorQty && tempDiscount?.max_purchase_qty && (tempDiscount?.min_purchase_qty > tempDiscount?.max_purchase_qty) && "The product max purchase quantity must more than min purchase quantity."}
                            onChange={(e) => setTempDiscount((prevValues) => ({
                                ...prevValues,
                                max_purchase_qty: e
                            }))}
                            type="number"
                            placeholder={""}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            sx={{ marginBottom: "0px" }}
                            control={
                                <Checkbox checked={tempDiscount?.is_ariba_discount}
                                    sx={{
                                        '&.Mui-checked': {
                                            color: "var(--bs-theme-color)",
                                        },
                                        color: '#52525280'
                                    }}
                                    onChange={(event) => setTempDiscount((prevValues) => ({
                                        ...prevValues,
                                        is_ariba_discount: event.target.checked ? 1 : 0
                                    }))}
                                    value={tempDiscount?.is_ariba_discount} />
                            }
                            label={<span style={{ fontFamily: 'Manrope', fontSize: 14 }}>Apply discount on Ariba Punchout Platform</span>}
                        />
                        <FormControlLabel
                            sx={{ marginBottom: "0px" }}
                            control={
                                <Checkbox checked={tempDiscount?.is_aspeed_discount}
                                    sx={{
                                        '&.Mui-checked': {
                                            color: "var(--bs-theme-color)",
                                        },
                                        color: '#52525280'
                                    }}
                                    onChange={(event) => setTempDiscount((prevValues) => ({
                                        ...prevValues,
                                        is_aspeed_discount: event.target.checked ? 1 : 0
                                    }))}
                                    value={tempDiscount?.is_aspeed_discount} />
                            }
                            label={<span style={{ fontFamily: 'Manrope', fontSize: 14 }}>Apply discount on Aventrix Ecommerce Platform</span>}
                        />
                        {error && tempDiscount?.is_aspeed_discount === false && tempDiscount?.is_aspeed_discount === false && <FormHelperText sx={{ color: "red" }}>The platform field is required.</FormHelperText>}
                    </Grid>
                </Grid>

            </Grid>
            <div className="pt-3">
                <CustomButton
                    title={'Save'}
                    press={() => (edit ? (handleSaveEdit(id)) : (handleAddDiscount()))}
                    height={40}
                    width={"100%"}
                    backgroundColor={'#101010'}
                    textColor={'white'}
                />
            </div>

        </div>
    );
};

function mapStateToProps({ }) {
    return {

    };
}


export default connect(mapStateToProps)(DiscountField);
